// material-ui
import { Typography } from '@mui/material';

// project imports
import { NavGroup } from './sub-sections'
import PropTypes from 'prop-types'

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ( { menuList } ) => {

    if (!Array.isArray(menuList) || menuList.length === 0) {
        return <Typography variant="h6" color="error" align="center">메뉴 항목을 찾을 수 없습니다</Typography>;
    }

    const navItems = menuList.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        메뉴 항목 오류
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

MenuList.propTypes = {
    menuList: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default MenuList;